import React from "react"
import ListPageContainer from "../../Common/jsx/ListPageContainer"
import { getEntitiesUrlParameters } from "../../Common/js/get_entities_url_parameters"
import withHooks from "../../Common/jsx/WithHooks"
import { strToSnakeCase, strToUpperSnakeCase } from "../../Common/js/string_utils"
import { getCharacteristics, patchCharacteristic } from "../../api/api_characteristic"

class CharacteristicsList extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = {
      isReadyToRender: false,
      listPagination: {
        itemsPerPage: 50,
        page: 1,
        totalItems: -1,
        firstPageUrl: "",
        lastPageUrl: "",
        previousPageUrl: "",
        nextPageUrl: "",
      },
      listOrders: {
        name: "asc",
      },
      listFilters: {
        isVisible: true,
        searchStrings: "",
      },
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntities = this.getEntities.bind(this)
    this.setEntityIsVisible = this.setEntityIsVisible.bind(this)
    this.getHeaders = this.getHeaders.bind(this)
    this.getFilters = this.getFilters.bind(this)
    this.getRows = this.getRows.bind(this)
    this.buildEntity = this.buildEntity.bind(this)
    this.listPaginationUpdate = this.listPaginationUpdate.bind(this)
    this.listOrdersUpdate = this.listOrdersUpdate.bind(this)
    this.listFiltersUpdate = this.listFiltersUpdate.bind(this)
  }

  componentDidMount() {
    this.getEntities()
  }

  async getEntities() {
    let parameters = getEntitiesUrlParameters(this.state.listPagination, this.state.listFilters, this.state.listOrders)

    // CONFIG ------------------------------------------------------------------------------------------------
    let entities = await getCharacteristics(parameters)
    // / CONFIG ----------------------------------------------------------------------------------------------

    let listPagination = {
      ...this.state.listPagination,
      ...{
        totalItems: entities["hydra:totalItems"],
        pageTypeUrl: entities["hydra:view"]["@id"],
        firstPageUrl: entities["hydra:view"]["hydra:first"],
        lastPageUrl: entities["hydra:view"]["hydra:last"],
        previousPageUrl: entities["hydra:view"]["hydra:previous"],
        nextPageUrl: entities["hydra:view"]["hydra:next"],
      },
    }

    this.setState({ isReadyToRender: true, listPagination, entities: entities["hydra:member"] })
  }

  async setEntityIsVisible(entity, isVisible, doneCallback) {
    await patchCharacteristic(entity.id, { isVisible: isVisible })

    this.getEntities()
    this.props.notif.success()
    if (doneCallback !== undefined) {
      doneCallback()
    }
  }

  // CONFIG ------------------------------------------------------------------------------------------------

  getHeaders() {
    return [
      {
        name: "id",
        title: this.props.t("form.id"),
        className: "text-center",
        sort: this.state.listOrders.id !== undefined ? this.state.listOrders.id : "",
      },
      {
        name: "name",
        title: this.props.t("form.name"),
        sort: this.state.listOrders.name !== undefined ? this.state.listOrders.name : "",
      },

      {
        name: "characType",
        title: "Type caractéristique",
        sort: this.state.listOrders.characType !== undefined ? this.state.listOrders.characType : "",
      },
      {
        name: "actions",
        title: this.props.t("app.actions"),
      },
    ]
  }

  getFilters() {
    return [
      {
        name: "searchStrings",
        type: "text",
        label: this.props.t("app.search"),
        value: this.state.listFilters.searchStrings,
      },
      {
        name: "isVisible",
        type: "checkbox",
        label: this.props.t("app.hideDeleted"),
        checked: this.state.listFilters.isVisible,
      },
    ]
  }

  buildEntity(entity) {
    entity.customFields = []
    return entity
  }

  getRows() {
    return this.state.entities.map((entity) => {
      entity = this.buildEntity(entity)

      let actions = []
      if (this.props.RightsManager.userHasRight(strToUpperSnakeCase(this.props.entityType) + ":EDIT")) {
        actions = actions.concat(["edit", "delete", "restore"])
      }

      return {
        entity: entity,
        fields: [
          {
            name: "id",
            value: entity.id,
            className: "text-center",
          },
          {
            name: "name",
            value: entity.name,
          },
          {
            name: "characType",
            value: entity.characType.name,
          },
          {
            name: "actions",
            actions: actions,
          },
        ],
      }
    })
  }
  // /CONFIG ------------------------------------------------------------------------------------------------

  listPaginationUpdate(parameters) {
    this.dMgr.debug("listPaginationUpdate parameters:", parameters)
    this.setState({ listPagination: { ...this.state.listPagination, ...parameters } }, this.getEntities)
  }

  listOrdersUpdate(order) {
    this.dMgr.debug("listOrdersUpdate order:", order)

    let listOrders = {}
    if (this.state.listOrders[order] !== undefined) {
      if (this.state.listOrders[order] === "asc") {
        listOrders[order] = "desc"
      } else {
        listOrders[order] = "asc"
      }
    } else {
      listOrders[order] = "asc"
    }
    this.setState({ listOrders: listOrders }, this.getEntities)
  }

  listFiltersUpdate(filters) {
    this.dMgr.debug("listFiltersUpdate filters:", filters)
    this.setState({ listFilters: { ...this.state.listFilters, ...filters } }, this.getEntities)
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <ListPageContainer
        tableName={"list_" + this.props.entitiesType}
        referrerUrl={"/admin/" + strToSnakeCase(this.props.entitiesType)}
        entityType={this.props.entityType}
        entitiesType={this.props.entitiesType}
        tableHeaders={this.getHeaders()}
        tableRows={this.getRows()}
        filters={this.getFilters()}
        listPagination={this.state.listPagination}
        listPaginationUpdate={this.listPaginationUpdate}
        listOrdersUpdate={this.listOrdersUpdate}
        listFilters={this.state.listFilters}
        listFiltersUpdate={this.listFiltersUpdate}
        deleteEntity={(entity, doneCallback) => this.setEntityIsVisible(entity, false, doneCallback)}
        restoreEntity={(entity) => this.setEntityIsVisible(entity, true)}
      />
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(CharacteristicsList)
